<template>
    <div class='table-box'>
        <global-tag>
            <el-form :inline='true' :model='searchlist' class='demo-form-inline' size='mini'>
                <el-form-item label='设备类型:'>
                    <el-select v-model='searchlist.equipmentTypeId' placeholder='请选择'>
                        <el-option v-for="(item, index) in typeList" :key="index" :label="item.dictLabel"
                            :value="item.dictCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='设备号:'>
                    <el-input v-model='searchlist.equipmentNumber' placeholder='请输入'></el-input>
                </el-form-item>
                <el-form-item label='设备名称:'>
                    <el-input v-model='searchlist.equipmentName' placeholder='请输入'></el-input>
                </el-form-item>
                <el-form-item label='设置状态：'>
                    <el-select v-model='searchlist.setFlag' placeholder='请选择'>
                        <el-option label='已设置' value='1'></el-option>
                        <el-option label='未设置' value='0'></el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item>
                    <el-button type='primary' icon='el-icon-search' @click='searchlistdata'>查询
                    </el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type='info' @click='searchlistReset'>重置
                    </el-button>
                </el-form-item>
                <el-form-item></el-form-item>
            </el-form>
        </global-tag>
        <div class='three'>
            <el-button type='primary' size='mini' @click="showDialog('新增')">新增设备
            </el-button>
        </div>
        <!-- 表格盒子 -->
        <div class='table_card'>
            <el-table :data='tableData' :header-cell-style="{ background: '#f8fafa' }" border highlight-current-row>
                <el-table-column fixed type="index" align="center" label="序号" width="60">
                </el-table-column>
                <el-table-column align='center' prop='equipmentTypeName' label='设备类型'></el-table-column>
                <el-table-column align='center' prop='equipmentBrandName' label='设备品牌'></el-table-column>
                <el-table-column align='center' prop='equipmentNumber' label='设备号'></el-table-column>
                <el-table-column align='center' prop='equipmentName' label='设备名称'></el-table-column>
                <el-table-column align='center' prop='equipmentAddress' label='设备位置'></el-table-column>
                <el-table-column align='center' prop='setFlag' label='设置状态'>
                    <template slot-scope="scope">
                        <span v-if="scope.row.setFlag == 1">已设置</span>
                        <span v-if="scope.row.setFlag == 0">未设置</span>
                    </template>
                </el-table-column>
                 <el-table-column align='center' prop='bindFlag' label='绑定状态'>
                    <template slot-scope="scope">
                        <span v-if="scope.row.bindFlag == 1">已绑定</span>
                        <span v-if="scope.row.bindFlag == 0">未绑定</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' label='操作' fixed='right' width="250">
                    <template slot-scope='scope'>
                          <button class='tabBtn tabBtn-detail'
                               @click="showDialog( '查看',scope.row)">查看</button>
                         <button class='tabBtn tabBtn-detail'
                               @click="showDialog( '修改',scope.row)">修改</button>
                         <button class='tabBtn tabBtn-edit' 
                            @click="showDialog('设置',scope.row)">{{scope.row.setFlag=='0'?'设置':'修改设置'}}</button>
                       <button class='tabBtn tabBtn-delete'
                                @click='deleteItem(scope.row.id)'>删除</button> 
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页功能 -->
            <el-pagination :page-size='pageConfig.pageSize' layout='total, prev, pager, next, jumper'
                @current-change='handleCurrentChange' :total='pageConfig.total'></el-pagination>
        </div>
        <addInfo ref='showFrom' @disClose='disClose' :dialogTitle="dialogTitle" :showDialogVisible="showDialogVisible" :typeList="typeList" :brandList="brandList"></addInfo>
    </div>
</template>

<script>
import '@/assets/css/system.css'
import { post } from '@/api/requrestHttp'
import addInfo from './components/addInfo.vue'
export default {
    components:{addInfo},
    data() {
        return {
            addForm: {},
            dialogTitle: '新增',
            showDialogVisible: false,
            searchlist: {},
            tableData: [],
            pageConfig: {
                pageSize: 10,
                total: 0,
                pageNo: 1
            },
            typeList: [],
            brandList: []
        }
    },
    methods: {
        async getTypeList() {
            let query = {
                pageNum: 1,
                pageSize: 999,
                dictType: "equipment_type",
            }
            this.$http
                .request({
                    url: "/rbac/system/dict/data/list",
                    method: "get",
                    params: query,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.rows != null) {
                            this.typeList = res.rows
                        }
                    }
                })
        },
        async getBrandList() {
            let query = {
                pageNum: 1,
                pageSize: 999,
                dictType: "equipment_brand",
            }
            this.$http
                .request({
                    url: "/rbac/system/dict/data/list",
                    method: "get",
                    params: query,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.rows != null) {
                            this.brandList = res.rows
                        }
                    }
                })
        },
        deleteItem(id) {
            this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const res = await post('ypt/admin/equipment/info/deleteById', { id: id })
                    if (res.code == 200) {
                        this.getTableData()
                    }
                })
                .catch(() => {
                    this.$message.info('已取消删除')
                })
        },
        
        //条件查询
        searchlistdata() {
            this.pageConfig.pageNo = 1
            this.getTableData()
        },
        searchlistReset() {
            this.searchlist = {}
            this.pageConfig.pageNo = 1
            this.getTableData()
        },
        //分页
        handleCurrentChange(val) {
            this.pageConfig.pageNo = val
            this.getTableData()
        },
        //获取列表数据
        async getTableData() {
            const { content } = await post('/ypt/admin/equipment/info/findList', {
                ...this.searchlist,
                ...this.pageConfig
            })
            if(content){
              this.tableData = content.list || []
             this.pageConfig.total = content.count
            }
            
        },
        async showDialog(type, row) {
            this.showDialogVisible = true
            this.dialogTitle = type
            if(type !=='新增'){
               this.$refs.showFrom.seeDialog(type,row.id,row.equipmentTypeId)
            }
        },
        disClose(){
            this.showDialogVisible = false
            this.getTableData()
        }
    },
     created(){
       this.searchlist.equipmentNumber = this.$route.query.equipmentNumber;
    },
    mounted() {
        this.getTypeList()
        this.getBrandList()
        this.getTableData()
    }
}
</script>
<style scoped>
    .tabBtn{
        font-size:13px;
        margin:0 2px;
    }
</style>
